module.exports = __webpack_public_path__ + "roboto-medium-webfont-7f0e4c7727a4bc5f37d95d804c6e0348.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-medium-webfont.ttf
// module id = 863
// module chunks = 86